import Pusher from 'pusher-js'
import { useMessageStore } from '../stores/messages'
import { useUserStore } from '../stores/user-store'
import { useMaintenanceStore } from '../stores/maintainence'
import { useRecruitmentNotificationsStore } from '../stores/recruitmentNotifications'

export default {
  install: (app: any, options: { apiKey: string; cluster: string; authEndpoint: string }) => {
    const messageStore = useMessageStore()
    const userStore = useUserStore()
    const maintenanceStore = useMaintenanceStore()
    const recruitmentStore = useRecruitmentNotificationsStore()

    // Initialize Pusher when user is authenticated
    if (userStore.token) {
      messageStore.initializePusher(options.apiKey, options.cluster, options.authEndpoint)
    }
    if (userStore.token) {
      maintenanceStore.initializePusher(options.apiKey, options.cluster, options.authEndpoint)
    }

    // Driver recruitment channel (public - no auth needed)
    if (userStore.token) {
      recruitmentStore.initializePusher(options.apiKey, options.cluster)
    }

    // Provide Pusher to components (single provide; messageStore is primary)
    app.provide('pusher', messageStore.pusher)
  },
}
